module.exports = __webpack_public_path__ + "static/media/emiliano_martinez.84086953.jpg";